module.exports = __webpack_public_path__ + "img/box-duotone.14b1e809.svg";